import Header from './landing/Header';
import Footer from './landing/Footer';
import { FaComments, FaArrowRight, FaCheck } from 'react-icons/fa';
import './ProductsPage.css';
import { useScrollReveal } from '../hooks/useScrollReveal';

const chatServeFeatures = [
  'Digital menus, ordering & table booking',
  'AI-powered WebChat available 24/7',
  'Facebook & WhatsApp integration',
  'Instant access via QR code scan',
];

function ProductsPage() {
  useScrollReveal();

  return (
    <div className="site">
      <Header />
      <main className="products-main">
        <section className="products-hero">
          <div className="products-hero-bg" aria-hidden="true">
            <span className="hero-blob hero-blob--1"></span>
            <span className="hero-blob hero-blob--2"></span>
          </div>
          <div className="section-content products-hero-content">
            <span className="hero-badge reveal">Our products</span>
            <h1 className="reveal reveal-delay-1">
              Software that moves your business forward
            </h1>
            <p className="reveal reveal-delay-2">
              Explore the products we&apos;ve crafted to help businesses engage
              customers and streamline operations.
            </p>
          </div>
        </section>

        <section className="products-section section">
          <div className="section-content">
            <div className="product-grid">
              <a
                href="https://staff-test.chatserve.eu/landing/"
                className="product-card reveal"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="product-card-top">
                  <div className="product-card-icon">
                    <FaComments />
                  </div>
                  <span className="product-card-tag">Live product</span>
                </div>

                <h2 className="product-card-title">ChatServe</h2>
                <p className="product-card-subtitle">
                  Elevate your guest experience &amp; streamline operations
                </p>
                <p className="product-card-text">
                  Transform how you connect with customers. ChatServe is the
                  all-in-one platform designed specifically for restaurants and
                  bars — empowering guests to browse menus, place orders, and
                  book tables through a sleek digital interface, with an
                  intelligent AI assistant that engages customers around the
                  clock.
                </p>

                <ul className="product-card-features">
                  {chatServeFeatures.map((feature) => (
                    <li key={feature}>
                      <FaCheck className="product-card-check" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <span className="product-card-cta">
                  Learn more &amp; get started
                  <FaArrowRight />
                </span>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ProductsPage;
